
import { api } from "../../services/Api";
import { Constants } from "../../util/Constants";
import { dataHoraAtualTruncOperacaoDiasFormatada, montaMenssagemRetornoErroPromiseAllSettled } from "../../util/FuncoesComuns";
import { HOJE, VENCER, VENCIDO } from "../AlertaExpedicao/utils/Constants";

const alertaFileDownload = (fileRequest: any, setMensagem: any, setShowToast: any) => {
    let qtdErroChamarNovamente = 0;
    try {
         let nomeArquivo = 'prazo.csv';
         let complemento = fileRequest.tipoAlerta === Constants.OEC ? 'loec' : 'expedicao';
         if(fileRequest.situacaoAlerta === HOJE) {
            fileRequest.dataInicio = dataHoraAtualTruncOperacaoDiasFormatada('ano','-',0,true).replaceAll(' ','T');
            fileRequest.dataFinal = dataHoraAtualTruncOperacaoDiasFormatada('ano','-',1,true).replaceAll(' ','T');
            nomeArquivo = `objetos_${complemento}_prazo_hoje_${dataHoraAtualTruncOperacaoDiasFormatada('dia','-',0,true).split(' ')[0].replaceAll('-','').replaceAll('/','')}.csv`;
         }else if (fileRequest.situacaoAlerta === VENCER) {
            fileRequest.dataInicio = fileRequest?.tipoAlerta === Constants.OEC ? dataHoraAtualTruncOperacaoDiasFormatada('ano','-',0,true).replaceAll(' ','T') : dataHoraAtualTruncOperacaoDiasFormatada('ano','-',1,true).replaceAll(' ','T');
            fileRequest.dataFinal = fileRequest?.tipoAlerta === Constants.OEC ? dataHoraAtualTruncOperacaoDiasFormatada('ano','-',1,true).replaceAll(' ','T') : dataHoraAtualTruncOperacaoDiasFormatada('ano','-',100,true).replaceAll(' ','T');
            nomeArquivo = `objetos_${complemento}_prazo_vencer_apos_${dataHoraAtualTruncOperacaoDiasFormatada('dia','-',0,true).split(' ')[0].replaceAll('-','').replaceAll('/','')}.csv`;
         }else if (fileRequest.situacaoAlerta === VENCIDO) {
            fileRequest.dataInicio = fileRequest?.tipoAlerta === Constants.OEC ? dataHoraAtualTruncOperacaoDiasFormatada('ano','-',0,true).replaceAll(' ','T') : dataHoraAtualTruncOperacaoDiasFormatada('ano','-',180,false).replaceAll(' ','T');
            fileRequest.dataFinal = fileRequest?.tipoAlerta === Constants.OEC ? dataHoraAtualTruncOperacaoDiasFormatada('ano','-',1,true).replaceAll(' ','T') : dataHoraAtualTruncOperacaoDiasFormatada('ano','-',0,true).replaceAll(' ','T');
            nomeArquivo = `objetos_${complemento}_prazo_vencido_antes_${dataHoraAtualTruncOperacaoDiasFormatada('dia','-',0,true).split(' ')[0].replaceAll('-','').replaceAll('/','')}.csv`;
         }

         fileRequest.nomeArquivo = nomeArquivo;

        // Step 1: Fetch data from the server
        (async function () {
          const [res] = await Promise.allSettled([
              api.post('/v1/file/csv',fileRequest)
          ]);
    
          // Step 2: Check if the response status is 200 (OK) and data is present
          if (res.status === 'fulfilled') {
              const url = window.URL.createObjectURL(new Blob([res.value.data]));
              const link = document.createElement('a');
              link.href = url;
              link.setAttribute('download', nomeArquivo);
              document.body.appendChild(link);
              link.click();
              //Step 3: Clean up the temporary URL
              document.body.removeChild(link);
              URL.revokeObjectURL(url);
              qtdErroChamarNovamente = 0;
          } else {

              let msg = montaMenssagemRetornoErroPromiseAllSettled(res,'Alerta : Não foi possível recuperar informações para gerar o arquivo csv.');
              if(msg && msg.includes('Timeout')){
                qtdErroChamarNovamente = qtdErroChamarNovamente++;
                msg = 'Alerta: Aguarde!'
              }

              setMensagem({ delay: 3000, tipo: 'warning', texto: msg, url: '/' });
              setShowToast(true);
          }

        })();

      } catch (error) {
        console.log("error: ",error);
        let msg = montaMenssagemRetornoErroPromiseAllSettled(error,'Alerta : Não foi possível recuperar informações para gerar o arquivo csv.');
        if(msg && msg.includes('Timeout')){
          qtdErroChamarNovamente = qtdErroChamarNovamente++;
          msg = 'Alerta: Aguarde!'
        }
        setMensagem({ delay: 3000, tipo: 'warning', texto: msg, url: '/' });
        setShowToast(true);
      }
      //Chamar novamente caso ocorra Timeout.
      if(qtdErroChamarNovamente > 0 && qtdErroChamarNovamente <= 3) {
        alertaFileDownload(fileRequest, setMensagem, setShowToast);
      }
}

export default alertaFileDownload;